import { Icon } from "@aws-amplify/ui-react";

export default function CheckIcon({isValid = true}) {
  return (
    <Icon
      width="17px"
      height="13px"
      viewBox={{
        minX: 0,
        minY: 0,
        width: 17,
        height: 13,
      }}
      paths={[
        {
          d: "M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z",
          fill: isValid ? "rgba(67,168,84,1)" : "rgba(102,0,0,1)",
          fillRule: "nonzero",
        },
      ]}
      position="absolute"
      top="23%"
      bottom="20%"
      left="14%"
      right="12%"
    ></Icon>
  );
}
